// extracted by mini-css-extract-plugin
export default {"section":"POR_section__3wW3w","heading":"POR_heading__P2I6L","cards":"POR_cards__NsBeV"};